import { replaceTitlePlaceholders } from "../../../commonComponent/TileSelectionComponent";   

export function replaceStepNumber(
    title: string,
    isEnglish: boolean,
    getCurrentBXPStepIndex: () => number | undefined
): string {
    if (!title) {
        return "";
    }

    const stepIndex = getCurrentBXPStepIndex();
    if (stepIndex === undefined) {
        return title;
    }

    const stepRegex = isEnglish
        ? /(Step\s*)(\d+)(:?\s*)/i
        : /(Étape\s*)(\d+)(:?\s*)/i;

    return replaceTitlePlaceholders(title.replace(
        stepRegex,
        (_, prefix, _num, suffix) =>
            `${prefix}${stepIndex + 1}${suffix}`
    ));
}
